interface TabPanelProps {
  id: string;
  active: boolean;
  children: React.ReactNode;
}

export default function TabPanel({ id, active, children }: TabPanelProps) {
  return (
    <div 
      id={id} 
      role="tabpanel" 
      aria-labelledby={`${id}-tab`}
      className={`mt-4 ${active ? 'block' : 'hidden'}`}
    >
      {children}
    </div>
  );
}